export default "__VITE_ASSET__6fC1u82H__"